export default __webpack_public_path__ + "static/media/Landing-gmm4.68745e57.png";